export default {
    logging: '/api/logging/v1/logging/desktop/log',
    login: '/api/security/v3/security/authorize',
    placements: '/api/content-delivery/v1/content-delivery/query/placements'
};
